<template>
            <div>
              <div class="innerSearch">
                    <div class="box">
                        <input ref="keyword" class="search-input" type="text" placeholder="请输入关键词">
                        <a href="javascript:void(0)" @click="ClickSearch()">搜索</a>
                    </div>
                </div>

                <!--展会活动-->
                <div class="selectfilter">
                    <FlatSelectFilter title="关键词" v-model="Tag" :options="list_key" />
                    <FlatSelectFilter title="时间" v-model="Year" :options="list_time" />
                </div>
                <div class="activityList">
                    <template v-if="total==0">
                        <div class="nodataTip">
                            <div class="ico">
                                <img src="../../assets/images/nodataTip.png" alt="">
                            </div>
                            <div class="text">暂无数据~</div>
                        </div>
                    </template>
                    <ul>
                        <template v-for="item in list">
                        <li class="clearfix" :key="item.id">
                                <router-link :to="{ name: 'popsciactivitydetail',params:{id:item.id} }">
                                <img :src="item.imgUrl" alt="">
                                <div class="text_info">
                                        <div class="title">{{item.title}}</div>
                                        <div class="activityCon">
                                            <p>主办单位：{{item.sponsor}}</p>
                                            <p>会议时间：{{item.timeStr}}</p>
                                            <p>会议地点：{{item.location}}</p>
                                        </div>
                                </div>
                                <div class="label" v-if="item.tags">
                                    <template v-for="(tag,index) in item.tags.split(',')">
                                        <span v-if="index<3" :key="'tag_'+index">{{tag}}</span>
                                    </template>
                                </div>
                                </router-link>
                        </li>
                        </template>
                    </ul>
                    <Pagination v-model="pageindex" :total="total" :pagesize="pagesize" />
                </div>
            </div>
</template>
<script>
import Pagination from '../../components/Common/Pagination'
import FlatSelectFilter from '../Common/FlatSelectFilter.vue';
import $ from 'jquery'
export default {
	 data(){
    return{
      CategoryId:3, 
      keyword:'',
      Tag:'',
      Year:'',
      list_time:[
             {item:'全部',value:0},
             {item:'2023',value:2023},
            {item:'2022',value:2022},
            {item:'2021',value:2021},
            {item:'2020',value:2020},
            {item:'2019',value:2019},
            {item:'2018',value:2018},
        ],
        list_key:[],
         list:[],
        total:0,
        pagesize:5,
        pageindex: 1,
    }
  },
  created(){
    this.GetList();
    this.GetHot();
  },
  components:{
    FlatSelectFilter,
    Pagination,
  },
  methods:{
      GetList() {
        //    this.loadingInstance = Loading.service({
        //         // 动画中的文字
        //         text:'加载中',
        //         // 要加载动画的容器
        //         target:'.app-container'
        //     });
            var url = "/pageapi/Activity/GetList";
            this.$http.post(url,{pageindex: this.pageindex,pagesize: this.pagesize,CategoryId:this.CategoryId,keyword:this.keyword,Year:this.Year,Tag:this.Tag}).then(function(res){
                if (res.data.status==1){
                    this.list=res.data.ds;
                    this.total=res.data.total;
                    this.loadingInstance.close();
                }
            }.bind(this)).catch(function(){
            });
        },
    ClickSearch: function () {
        this.keyword = $(this.$refs.keyword).val();
    },
    GetHot(){
      var url = "/pageapi/Common/GetFieldDic";
            this.$http.post(url,{name:'activity_hot_words'}).then(function(res){
                if (res.data.status==1){
                  var temp=[{item:'全部',value:''}];
                  temp=temp.concat(res.data.ds);
                  this.list_key=temp;
                }
            }.bind(this)).catch(function(){
            });
    },
    PropsChange() {
            if (this.pageindex!=1){
            this.pageindex=1;
            }else{
            this.GetList();
            }
        },
  },
   watch:{
        pageindex:function(){
            this.GetList();
        },
        keyword(){
            this.PropsChange();
        },
        $route(){
            this.PropsChange();
        },
        CategoryId(){
            this.PropsChange();
        },
        Tag(){
            this.PropsChange();
        },
        Year(){
            this.PropsChange();
        },
    }
}
</script>
